// 현재 날짜를 기준으로 현재 달의 마지막 날짜를 구하기
let currentDate = new Date();
let currentDay = currentDate.getDate();
let currentMonth = currentDate.getMonth() + 1;
let currentYear = currentDate.getFullYear();
let viewMonth = currentMonth; //화면에 보여줄 month

//GET 방식으로 온 month 매개변수 확인
let url = new URL(top.window.location.href);
let urlParams = new URLSearchParams(url.search);
let monthValue = urlParams.get('month');
let dayValue = urlParams.get('day');
let fishType = urlParams.get('fishType');

dayValue = !dayValue == true ? currentDay : dayValue;

//year month 결정
if(!!monthValue){
    //년(year) 결정
    currentYear = currentMonth > monthValue ? parseInt(currentYear+1) : currentYear;
    viewMonth = monthValue;    
}

/**
 * 숫자를 문자열로 변환하여 길이가 1인 경우 앞에 '0'을 붙여 반환
 * @param {int} num 
 * @returns string "00"
 */
function addZero(num) {
    return num < 10 ? '0' + num : num.toString();
}

//예약 날짜
let bookDate = new Date(currentYear + "-" + addZero(viewMonth) + "-" + addZero(dayValue));
let dayNum = bookDate.getDay();

/**
 * 요일 글자 변환
 * @param {int} dayNumber 
 * @returns string "월"
 */
let transWord = function (dayNumber) {
    let dayWord = "";
    switch (dayNumber) {
        case 0: dayWord = "일";
            break;
        case 1: dayWord = "월";
            break;
        case 2: dayWord = "화";
            break;
        case 3: dayWord = "수";
            break;
        case 4: dayWord = "목";
            break;
        case 5: dayWord = "금";
            break;
        case 6: dayWord = "토";
            break;
    }
    return dayWord;
}


let dataset = {
    year: currentYear,
    month : addZero(viewMonth),
    day: dayValue,
    dayText: transWord(dayNum),
    fishType: fishType
}

let getWriteData = function(){
    return dataset;
}

export default {getWriteData}